import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';

export const dateIsGreaterThan7Days = (lastViewedDateString) => {
  const lastViewedDate = dayjs(lastViewedDateString, 'YYYY-MM-DD HH:mm');
  const datePlus7Days = lastViewedDate.add(7, 'day');
  const currentDate = dayjs();

  return currentDate.isAfter(datePlus7Days);
};

export const dateIsGreaterThanNDays = (lastViewedDateString, n) => {
  const lastViewedDate = dayjs(lastViewedDateString, 'YYYY-MM-DD HH:mm');
  const datePlusNDays = lastViewedDate.add(n, 'day');
  const currentDate = dayjs();

  return currentDate.isAfter(datePlusNDays);
}

export const convertMillisecondsToDate = (milliseconds, dateFormat) => {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  dayjs.extend(advancedFormat);

  const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const date = dayjs(milliseconds).tz(localTimezone);
  const timezoneAbbreviation = date.tz(localTimezone).format('z');

  const formattedDate = date.format(dateFormat);
  const formattedTime =
    date.minute() === 0 ? date.format('hA') : date.format('h:mm A');

  return {
    date: formattedDate,
    time: formattedTime,
    timezone: timezoneAbbreviation,
  };
};
